import { ChipSelect } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<CssColumnGrid columns={1}>
			<ChipSelect
				buttonText="Chip Select"
				items={items}
			/>
		</CssColumnGrid>
	);
};